import { useEffect, useState } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useChatAuth } from './components/AIchatbot/Auth/ChatAuthProvider';
import { Route, Routes, useLocation } from 'react-router';
import PrivateRoute from './components/Login/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import Login_Page from './components/Login/Login_Page';
import Sign_Up from './components/Login/Sign_Up';
import Pagenotfound from './components/views/PageNotFound';
import CreateInterview from './components/views/CreateInterview';
import MainLayout from './components/layout/MainLayout';
import ResultPage from './components/views/Result';
import ChatLogin_Page from './components/AIchatbot/Auth/AichatLogin';
import ChatSign_Up from './components/AIchatbot/Auth/ChatSign_Up';
import ChatVerifyOtp from './components/AIchatbot/Auth/ChatVerifyOpt';
import UserChatApp from './components/AIchatbot/chat/UserChatApp';
import AdminChatApp from './components/AIchatbot/chat/AdminChatApp';
import TechPred from './components/TechPred';
import TechPredLogin from './components/TechPred/Auth/TechPredLogin';
import TechPredPrivateRoute from './components/TechPred/Auth/TechPredPrivateRoute';
import DashBoardsFields from './components/DashBoardsFields';
import './App.css';
import HeaderCom from './components/AIchatbot/HeaderComponents/headerCom';
import { TechPredheader } from './components/TechPred/TechPredHeader';
import JobDescLogin from './guntechjobdesc/Job_Description/Auth/JobDescLogin';
import JobDescPrivateRoute from './guntechjobdesc/Job_Description/Auth/JobDescPrivateRoute';
import JobDescriptionGenerator from './guntechjobdesc/Job_Description/HomePage';
import ChatPrivateRoute from './components/AIchatbot/Auth/ChatPrivateRoute';
import LandingTechPred from './components/TechPred/landingTechPred';

function MainSection() {
  const fullscrnhandle = useFullScreenHandle();
  const [isFullscreen, setIsFullscreen] = useState();
  const [showTechPred, setShowTechPred] = useState(false);
  const [showHeader, setshowheader] = useState(false);
  const location = useLocation();
  const { hash, pathname, search } = location;
  useEffect(() => {
    if (pathname.includes('interview') || pathname.includes('aichatbot')) {
      setshowheader(true);
    } else {
      setshowheader(false);
    }

    if (pathname.includes('techpred')) {
      setShowTechPred(true);
    } else {
      setShowTechPred(false);
    }
  }, [location]);
  return (
    <FullScreen handle={fullscrnhandle}>
      <div
        className="App"
        style={{
          // padding: "30px",

          paddingTop: '0px',
          height: '100%',
          //backgroundColor: location.pathname === '/aichatbot/userchat' || '/aichatbot/admin' ? 'transparent' : '#e0e0e0'
          backgroundColor: location.pathname === '/aichatbot/userchat' || '/aichatbot/admin' ? '#f5f5f5' : '#e0e0e0'
          // backgroundImage: "",
        }}
      >
        {showHeader && <HeaderCom />}
        {showTechPred && <TechPredheader />}
        <div
          style={{
            padding:
              window.location.hash.includes('/aichatbot/userchat') || window.location.hash.includes('/aichatbot/admin') ? '0px' : '20px',
            paddingTop:
              window.location.hash.includes('/aichatbot/userchat') || window.location.hash.includes('/aichatbot/admin') ? '0px' : '100px'
          }}
        >
          <Routes>
            <Route path="/interview">
              <Route path="" element={<Login_Page />} />
              <Route path="signup" element={<Sign_Up />} />
              <Route
                path="createinterview"
                element={
                  <PrivateRoute>
                    <CreateInterview />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Pagenotfound />} />
              <Route path="startinterview/:id/:user_email/:password" element={<MainLayout fullscrnhandle={fullscrnhandle} />} />
              <Route
                path="result/:interviewid"
                element={
                  <PrivateRoute>
                    <ResultPage />
                  </PrivateRoute>
                }
              />
            </Route>
            {/* //chat bot routes */}
            <Route path="aichatbot">
              <Route path="login" element={<ChatLogin_Page />} />
              <Route path="signup" element={<ChatSign_Up />} />
              <Route path="verifyotp" element={<ChatVerifyOtp />} />
              <Route path="userchat/:useremail/:token/:jwt?" element={<UserChatApp />} />
              <Route path="admin/:useremail/:token/:jwt?" element={<AdminChatApp />} />
              <Route
                path="dashboard/*"
                element={
                  <ChatPrivateRoute>
                    <DashBoardsFields />
                  </ChatPrivateRoute>
                }
              />
              {/* <Route
                  path="home"
                  element={
                    <ChatPrivateRoute>
                      <Home />
                    </ChatPrivateRoute>
                  }
                /> */}
            </Route>
            <Route path="techpred">
              <Route path="*" element={<Pagenotfound />} />
              <Route path="home" element={<LandingTechPred />} />
              <Route path="login" element={<TechPredLogin />} />
              <Route
                path="chat"
                element={
                  <TechPredPrivateRoute>
                    <TechPred />
                  </TechPredPrivateRoute>
                }
              />
            </Route>

            <Route path="/jobdescription">
              <Route path="*" element={<Pagenotfound />} />
              <Route path="login" element={<JobDescLogin />} />
              <Route
                path="generate"
                element={
                  <JobDescPrivateRoute>
                    <JobDescriptionGenerator />
                  </JobDescPrivateRoute>
                }
              />
            </Route>
          </Routes>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={3000} draggable pauseOnHover theme="colored" />
    </FullScreen>
  );
}

export default MainSection;
